import Vuex from 'vuex';
// import { cookies } from '../cookies.js';

export function createStore(context) {
  let sectionSlugToIdMapCache = {};
  let categorySlugToIdMapCache = {};
  let subcategorySlugToIdMapCache = {};

  return new Vuex.Store({
    state: () => ({
      node_env: process.env.NODE_ENV,
      django_env: context.djangoEnv,
      countryCode: context.countryCode,
      language: context.language,
      currency: context.currency,
      currencySymbol: context.currencySymbol,
      translations: context.translations,
      categories: context.categories,
      ssrUrl: context.url,
      hitsPerPage: 48,
      labels: {
        FAT: null,
        MIL: null,
        LOCP: null,
        ANF: null,
        SUPLC: null,
      },
      colors: {
        Black: null,
        Grey: null,
        Blue: null,
        Red: null,
        Pink: null,
        Beige: null,
        Purple: null,
        Yellow: null,
        Green: null,
        White: null,
        Brown: null,
        Orange: null,
        Denim: null,
        'Other/Multi': null,
      },
      algolia: context.algolia || {
        indexName: null,
        applicationID: null,
        searchAPIKey: null,
        queryID: null,
      },
      typesense: context.typesense || {
        collectionName: null,
        searchAPIKey: null,
      },
      excludedClearRefinements: [
        'women_categories.lvl0',
        'women_categories.lvl1',
        'men_categories.lvl0',
        'men_categories.lvl1',
        'kids_categories.lvl0',
        'kids_categories.lvl1',
        'home_categories.lvl0',
        'home_categories.lvl1',
        'beauty-care_categories.lvl0',
        'beauty-care_categories.lvl1',
      ],
      catalog: {
        path: null,
        title: null,
        pagetype: null,
        intro: null,
        footer: null,
        labels: null,
        certificates: null,
        buttons: null,
        image: null,
        subcategoryFilters: null,
        subcategorySuggestions: null,
        store: {
          name: null,
          slug: null,
        },
        brand: {
          name: null,
          slug: null,
        },
        store_url: null,
        breadcrumbs: null,
      },
      favorites: [],
      storeCountries: context.storeCountries || {},
      materials: context.materials || {},
      imageresults: context.results,
      infinitescrollABtest: context.infinitescroll_abtest,
      enableInfinitescrollABtest: context.enable_infinitescroll_abtest,
    }),

    actions: {
      async setCatalogContext({ commit, state }, { path }) {
        if (path === state.catalog.path) return;
        const result = await fetch(
          `/api/v0/catalog/context/?format=json&path=${encodeURIComponent(
            path
          )}`
        );
        const json = await result.json();
        commit('setCatalogContext', json);
      },
    },

    mutations: {
      setCatalogContext(
        state,
        {
          path,
          pagetitle,
          pagetype,
          page_intro,
          page_footer,
          page_img,
          page_labels,
          page_certificates,
          buttons,
          subcategory_filters,
          subcategory_suggestions,
          store_name,
          store_slug,
          brand_name,
          brand_slug,
          store_url,
          breadcrumbs,
        }
      ) {
        state.catalog.path = path;
        state.catalog.title = pagetitle;
        state.catalog.pagetype = pagetype;
        state.catalog.intro = page_intro;
        state.catalog.footer = page_footer;
        state.catalog.labels = page_labels;
        state.catalog.certificates = page_certificates;
        state.catalog.buttons = buttons;
        state.catalog.subcategoryFilters = subcategory_filters;
        state.catalog.subcategorySuggestions = subcategory_suggestions;
        state.catalog.image = page_img;
        state.catalog.store = {
          name: store_name,
          slug: store_slug,
        };
        state.catalog.brand = {
          name: brand_name,
          slug: brand_slug,
        };
        state.catalog.store_url = store_url;
        state.catalog.breadcrumbs = breadcrumbs;
      },
      setLabels(state, labels) {
        state.labels = labels;
      },
      setColors(state, colors) {
        state.colors = colors;
      },
      setHitsPerPage(state, hitsPerPage) {
        state.hitsPerPage = hitsPerPage;
      },
      setFavorites(state, favorites) {
        state.favorites = favorites;
      },
      setQueryID(state, queryID) {
        state.algolia.queryID = queryID;
      },
    },
    getters: {
      getCountryName: state => id => {
        if (state.storeCountries[id]) {
          return state.storeCountries[id];
        }
        console.warn(`No translation for country with id '${id}'`);
        return id;
      },
      getMaterialName: state => id => {
        if (state.materials[id]) {
          return state.materials[id];
        }
        console.warn(`No translation for material with id '${id}'`);
        return id;
      },
      getColor: state => key => {
        if (state.colors[key]) {
          return state.colors[key];
        }
        console.warn(`No translation for color with key '${key}'`);
        return key;
      },
      getAffiliateOutlink: state => url => {
        var visitor = '';
        if (typeof document !== 'undefined') {
          var value = ';' + document.cookie;
          if (document.cookie.indexOf(value) > 1) {
            var parts = value.split(';_pk_id.');
            visitor = parts
              .pop()
              .split(';')
              .shift()
              .split('=')[1]
              .split('.')[0];
          }
          // var visitor = cookies.getCookie('cece');
        }

        if (!visitor) {
          visitor = 'projectcece';
        }
        var tracking =
          'utm_source=project_cece&utm_campaign=cece_' +
          state.countryCode.toLowerCase() +
          '&cece=' +
          visitor;
        var add = '?';
        if (url.indexOf('?') > 1) add = '&';
        var outlink = url + add + tracking;
        return outlink;
      },
      sectionSlugToIdMap: state => {
        if (Object.keys(sectionSlugToIdMapCache).length != 0)
          return sectionSlugToIdMapCache;
        sectionSlugToIdMapCache = Object.keys(state.categories).reduce(
          (map, sectionId) => {
            map[state.categories[sectionId].slug] = sectionId;
            map[state.categories[sectionId].local_slug] = sectionId;
            map[sectionId] = sectionId;
            return map;
          },
          {}
        );

        console.log('sectionSlugToIdMapCache');
        console.log(sectionSlugToIdMapCache);

        return sectionSlugToIdMapCache;
      },
      // categoryUrlToIdMap: state => sectionId => {
      //   // Return cache if available
      //   if (categoryUrlToIdMapCache[sectionId])
      //     return categoryUrlToIdMapCache[sectionId];

      //   // Generate a map where the key is the category slug and the
      //   // value is the category id
      //   categoryUrlToIdMapCache[sectionId] = Object.keys(
      //     state.categories[sectionId].c
      //   ).reduce((map, categoryId) => {
      //     map[state.categories[sectionId].c[categoryId].slug] = categoryId;
      //     return map;
      //   }, {});

      //   return categorySlugToIdMapCache[sectionId];
      // },
      categorySlugToIdMap: state => sectionId => {
        // Return cache if available
        if (categorySlugToIdMapCache[sectionId])
          return categorySlugToIdMapCache[sectionId];

        // Generate a map where the key is the category slug and the
        // value is the category id
        categorySlugToIdMapCache[sectionId] = Object.keys(
          state.categories[sectionId].c
        ).reduce((map, categoryId) => {
          map[state.categories[sectionId].c[categoryId].slug] = categoryId;
          return map;
        }, {});

        return categorySlugToIdMapCache[sectionId];
      },
      subcategorySlugToIdMap: state => sectionId => {
        // Return cache if available
        if (subcategorySlugToIdMapCache[sectionId])
          return subcategorySlugToIdMapCache[sectionId];

        // Initialize an empty map for the section
        subcategorySlugToIdMapCache[sectionId] = {};

        // Get categories for the section
        const categories = state.categories[sectionId].c;

        // Iterate over each category in the section
        Object.keys(categories).forEach(categoryId => {
          const subcategories = categories[categoryId].s;

          // Iterate over each subcategory in the category
          Object.keys(subcategories).forEach(subcategoryId => {
            const subcategory = subcategories[subcategoryId];
            // Map subcategory slug to subcategory ID
            // subcategorySlugToIdMapCache[sectionId][subcategory.slug] = subcategoryId;
            subcategorySlugToIdMapCache[sectionId][subcategory.slug] = {
              subcategoryId: subcategoryId,
              categoryId: categoryId,
            };
          });
        });

        return subcategorySlugToIdMapCache[sectionId];
      },
      // subcategorySlugToIdMap: state => (sectionId, categoryId) => {
      //   // Return cache if available
      //   if (subcategorySlugToIdMapCache[sectionId + categoryId])
      //     return subcategorySlugToIdMapCache[sectionId + categoryId];

      //   // Generate a map where the key is the category slug and the
      //   // value is the category id
      //   subcategorySlugToIdMapCache[sectionId] = Object.keys(
      //     state.categories[sectionId].c
      //   ).reduce((map, categoryId) => {
      //     map[state.categories[sectionId].c[categoryId].slug] = categoryId;
      //     return map;
      //   }, {});

      //   // Generate a map where the key is the category slug and the
      //   // value is the category id
      //   subcategorySlugToIdMapCache[sectionId] = Object.keys(
      //     state.categories[sectionId].c[categoryId].s
      //   ).reduce((map, subcategoryId) => {
      //     map[state.categories[sectionId].c[categoryId].s[subcategoryId].slug] =
      //       subcategoryId;
      //     return map;
      //   }, {});

      //   // // Generate a map where the key is the category slug and the
      //   // // value is the category id
      //   // subcategorySlugToIdMapCache[sectionId + categoryId] = Object.keys(
      //   //   state.categories[sectionId].c[categoryId].s
      //   // ).reduce((map, subcategoryId) => {
      //   //   map[state.categories[sectionId].c[categoryId].s[subcategoryId].slug] =
      //   //     subcategoryId;
      //   //   return map;
      //   // }, {});

      //   return subcategorySlugToIdMapCache[sectionId + categoryId];
      // },
    },
  });
}
